import {composeReducers, createReducerFunction} from 'immer-reducer'
import defaultState from 'redux/jobs/state'
import Jobs from 'redux/jobs/jobs.duck'
import JobsGridSession from 'redux/jobs/gridSession.duck'
import RescheduleJobs from 'redux/jobs/rescheduleJobs.duck'

export default composeReducers(
  createReducerFunction(Jobs, defaultState),
  createReducerFunction(JobsGridSession, defaultState),
  createReducerFunction(RescheduleJobs, defaultState)
)
